import { POSITION, useToast } from 'vue-toastification'

const toast = useToast()

export const toastConfig = {
  position: POSITION.TOP_CENTER,
  maxToasts: 3,
  filterBeforeCreate: (toast, toasts) => {
    if (toasts.filter(
      t => t.type === toast.type && t.message === toast.message
    ).length !== 0) {
      // Returning false discards the toast
      return false;
    }
    // You can modify the toast if you want
    return toast;
  }
}

export const Notification = {
  success(message) {
    toast.success(message)
  },
  error(message) {
    toast.error(message)
  },
  info(message) {
    toast.info(message)
  },
  warning(message) {
    toast.warning(message)
  },
}
